<div class="d-flex justify-content-center">
  <div class="managebooking-container {{ !isModal() && 'my-5 py-5' }}"
    [class.w-100]="isModal()"
  >
    @if (!isModal()) {
      <h2
        class="managebooking-title text-center font-weight-normal lh-44 huge-font-size"
        [innerText]="storeSvc.localeObj()?.tf_1_Calendar_Loyalty_ResvHistory_Action_Manage_Booking_link"
      ></h2>
      <p
        class="text-center pt-2 mb-4 pb-3"
        [innerHTML]="storeSvc.localeObj()?.tf_04_Checkout_manageBooking_description"
      ></p>
    }

    <app-textbox
      required="true"
      type="text"
      [label]="storeSvc.localeObj()?.tf_5_Confirmation_manageBooking_reservationID"
      [bindValue]="resID()"
      (onChange)="resID.set($event)"
    />
    <app-textbox
      required="true"
      type="email"
      [label]="storeSvc.localeObj()?.tf_4_Confirmation_guestdetails_emailaddress"
      [bindValue]="email()"
      (onChange)="email.set($event)"
    />
    <app-button-group
      [options]="buttonGroupOptions()"
      [classes]="isModal() ? 'd-flex justify-content-end' : 'd-block'"
      (onClickEvent)="handleButtonGroupClick($event)"
    ></app-button-group>
  </div>
</div>
